import { useEffect } from "react";

const StripePricingTable = () => {
  useEffect(() => {
    const scriptId = "stripe-pricing-table-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="w-full flexflex-row justify-center">
      <stripe-pricing-table
        pricing-table-id="prctbl_1STETkIi97HdpkQKphMaz5BA"
        publishable-key="pk_live_51RsmzmIi97HdpkQKhkuJ2MGCNWNgnqLVL4RcjcoIuhicyHLk3DtdE34go1rfG5ZDHBfuilMNRChiBLIyNQRhP8dM0064CBVd3R"
      />
    </div>
  );
};

export default StripePricingTable;
